import { GET_BRANCHES } from '../actionTypes/BranchActionType';

const BRANCH_STATE = {
  branchList: [],
};

const BranchReducer = (state = BRANCH_STATE, action) => {
  switch (action.type) {
    case GET_BRANCHES:
      return { ...state, branchList: action.payload };
    default:
      return state;
  }
};

export default BranchReducer;
